// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu_container__G2RtC {
  height: 100%;
  justify-content: center;
  padding: 46px 24px;
  margin-right: 40px;
}
.SideMenu_logo__QpfBT {
  cursor: pointer;
  width: 230px;
}
.SideMenu_container__G2RtC,
.SideMenu_items__HShYt {
  display: flex;
  flex-direction: column;
}
.SideMenu_items__HShYt {
  margin-top: 55px;
  row-gap: 4px;
}
.SideMenu_helpItemContainer__BIYmX {
  margin-top: 134px;
}
.SideMenu_item__Pujlg {
  align-items: center;
  column-gap: 12px;
  cursor: pointer;
  display: flex;
  height: 48px;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
  width: 198px;
}
.SideMenu_item__Pujlg:hover {
  background-color: #e6e6e6;
  border-radius: 4px;
}
.SideMenu_itemActive__916f6 {
  align-items: center;
  background-color: #cb9c2d;
  border-radius: 4px;
  column-gap: 12px;
  cursor: pointer;
  display: flex;
  height: 48px;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
  width: 198px;
}
.SideMenu_itemActive__916f6 .SideMenu_itemText__I5L6j {
  color: #fff;
}
.SideMenu_itemText__I5L6j {
  color: #5f6d7e;
  cursor: pointer;
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
}
.SideMenu_itemText__I5L6j,
.SideMenu_spanSeparator__lLGPK {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
}
.SideMenu_itemIcon__H466- {
  height: 22px;
  width: 22px;
  stroke: #5f6d7e;
}
.SideMenu_itemActive__916f6 .SideMenu_itemIcon__H466- {
  filter: brightness(1000%);
}
.SideMenu_separator__DeYf3 {
  display: flex;
  align-items: center;
  justify-content: baseline;
  gap: 6px;
  padding: 16px 0px 16px 16px;
}
.SideMenu_spanSeparator__lLGPK {
  font-size: 14px;
  text-align: left;
  color: #9fa7b2;
}
.SideMenu_divider__iX5Ib {
  width: 134px;
  border: 1px solid #e0e0e0;
}

@media screen and (max-width: 1280px) {
  .SideMenu_container__G2RtC {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sideMenu/SideMenu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  height: 100%;\n  justify-content: center;\n  padding: 46px 24px;\n  margin-right: 40px;\n}\n.logo {\n  cursor: pointer;\n  width: 230px;\n}\n.container,\n.items {\n  display: flex;\n  flex-direction: column;\n}\n.items {\n  margin-top: 55px;\n  row-gap: 4px;\n}\n.helpItemContainer {\n  margin-top: 134px;\n}\n.item {\n  align-items: center;\n  column-gap: 12px;\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n  width: 198px;\n}\n.item:hover {\n  background-color: #e6e6e6;\n  border-radius: 4px;\n}\n.itemActive {\n  align-items: center;\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  column-gap: 12px;\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n  width: 198px;\n}\n.itemActive .itemText {\n  color: #fff;\n}\n.itemText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 22px;\n  margin: 0px;\n}\n.itemText,\n.spanSeparator {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n}\n.itemIcon {\n  height: 22px;\n  width: 22px;\n  stroke: #5f6d7e;\n}\n.itemActive .itemIcon {\n  filter: brightness(1000%);\n}\n.separator {\n  display: flex;\n  align-items: center;\n  justify-content: baseline;\n  gap: 6px;\n  padding: 16px 0px 16px 16px;\n}\n.spanSeparator {\n  font-size: 14px;\n  text-align: left;\n  color: #9fa7b2;\n}\n.divider {\n  width: 134px;\n  border: 1px solid #e0e0e0;\n}\n\n@media screen and (max-width: 1280px) {\n  .container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideMenu_container__G2RtC`,
	"logo": `SideMenu_logo__QpfBT`,
	"items": `SideMenu_items__HShYt`,
	"helpItemContainer": `SideMenu_helpItemContainer__BIYmX`,
	"item": `SideMenu_item__Pujlg`,
	"itemActive": `SideMenu_itemActive__916f6`,
	"itemText": `SideMenu_itemText__I5L6j`,
	"spanSeparator": `SideMenu_spanSeparator__lLGPK`,
	"itemIcon": `SideMenu_itemIcon__H466-`,
	"separator": `SideMenu_separator__DeYf3`,
	"divider": `SideMenu_divider__iX5Ib`
};
export default ___CSS_LOADER_EXPORT___;
